// template here
import React from 'react'
import { useToast } from '../../hooks/useToast'
import logoWhite from '../../images/logo-white.svg'
import logoColour from '../../images/logo-colour.svg'
import logoColourDark from '../../images/logo-colour-dark.svg'
import { StepDots } from '../StepDots/StepDots'
import { Toast } from '../Toast/Toast'
import './AuthForm.scss'

interface AuthFormProps {
  useProgress?: boolean
  hideLogo?: boolean
  totalSteps?: number
  currentStep?: number
  children: React.ReactNode
  error?: React.ReactElement | string
  cardFooter?: React.ReactElement
}

export const AuthForm = (props: React.PropsWithChildren<AuthFormProps>): React.ReactElement => {
  const { useProgress, hideLogo, error, children, cardFooter } = props
  const { toast } = useToast()

  const totalSteps = props.totalSteps || 0
  const currentStep = props.currentStep || 0

  return (
    <div className="bg-body">
      {toast ? <Toast {...toast} /> : null}
      <div style={{ height: '100vh' }} className="d-flex min-vh-100 flex-column">
        <div className="d-flex container flex-fill">
          <div className="col-sm-10 col-lg-8 col-xl-6 m-auto">
            {!hideLogo && useProgress && (
              <>
                <img
                  src={logoColour}
                  alt="Citrus Logo"
                  className="img-responsive d-block mx-auto py-3 dark-only"
                  width="200"
                />
                <img
                  src={logoColourDark}
                  alt="Citrus Logo"
                  className="img-responsive d-block mx-auto py-3 light-only"
                  width="200"
                />
              </>
            )}
            {useProgress ? <StepDots totalSteps={totalSteps} currentStep={currentStep} /> : null}
            {error ? <div className="alert alert-primary">{error}</div> : null}
            <div className="card my-3 shadow-sm bg-body-tertiary border">
              <div className="card-body">
                {!hideLogo && !useProgress && (
                  <>
                    <img
                      src={logoColour}
                      alt="Citrus Logo"
                      className="img-responsive d-block mx-auto py-3 dark-only"
                      width="200"
                    />
                    <img
                      src={logoColourDark}
                      alt="Citrus Logo"
                      className="img-responsive d-block mx-auto py-3 light-only"
                      width="200"
                    />
                  </>
                )}
                {children}
              </div>
            </div>
            {cardFooter}
          </div>
        </div>
        <footer className="text-body-secondary d-lg-flex w-100 justify-content-center text-center pb-2 pt-5 mt-auto">
          <img
            src={logoWhite}
            className="light-img d-block d-md-inline mx-md-2 my-1 mx-auto"
            alt="Citrus"
            style={{ height: '1rem' }}
          />
          <span className="d-block d-md-inline mx-2">Software to build your sports business</span>
          <span className="d-block d-md-inline">
            <a
              href="https://www.joincitrus.com/privacy-policy"
              className="text-body-secondary mx-2"
            >
              Privacy
            </a>
            <a
              href="https://www.joincitrus.com/terms-of-service"
              className="text-body-secondary mx-2"
            >
              Terms
            </a>
            <a href="https://www.joincitrus.com/contact" className="text-body-secondary mx-2">
              Contact Us
            </a>
          </span>
        </footer>
      </div>
    </div>
  )
}
